import { Dictionary } from "../../common/types/Dictionary";

export enum INDUSTRY {
  ACCOMODATION_FOOD = "ACCOMODATION_FOOD",
  ADMINISTRATIVE_SUPPORT = "ADMINISTRATIVE_SUPPORT",
  AGRICULTURE = "AGRICULTURE",
  ARTS_RECREATION = "ARTS_RECREATION",
  BUILDING_CONSTRUCTION = "BUILDING_CONSTRUCTION",
  FINANCIAL_INSURANCE = "FINANCIAL_INSURANCE",
  FISHERIES = "FISHERIES",
  FORESTRY = "FORESTRY",
  HEALTH_BEAUTY = "HEALTH_BEAUTY",
  INFORMATION_TELECOMMUNICATION = "INFORMATION_TELECOMMUNICATION",
  MANUFACTURING = "MANUFACTURING",
  PROFESSIONAL = "PROFESSIONAL",
  RENTAL_REAL_ESTATE = "RENTAL_REAL_ESTATE",
  RETAIL_WHOLESALE_TRADE = "RETAIL_WHOLESALE_TRADE",
  TOURISM = "TOURISM",
  TRANSPORT_WAREHOUSING = "TRANSPORT_WAREHOUSING",
}

export enum INDUSTRY_ACCOMODATION_FOOD {
  HOTELS = "HOTELS",
  MOTELS = "MOTELS",
  SERVICED_APARTMENTS = "SERVICED_APARTMENTS",
  OTHER_ACCOMODATION = "OTHER_ACCOMODATION",
  CAFES = "CAFES",
  RESTAURANTS = "RESTAURANTS",
  TAKEAWAYS = "TAKEAWAYS",
  PUBS = "PUBS",
  BARS = "BARS",
  OTHER_FOOD = "OTHER_FOOD",
}

export enum INDUSTRY_ADMINISTRATIVE_SUPPORT {
  EMPLOYMENT = "EMPLOYMENT",
  ADMINISTRATIVE = "ADMINISTRATIVE",
  DOMESTIC_COMMERCIAL_CLEANING = "DOMESTIC_COMMERCIAL_CLEANING",
  PEST_CONTROL = "PEST_CONTROL",
  GARDENING = "GARDENING",
  PACKAGING = "PACKAGING",
  SUPPORT_OPERATIONS = "SUPPORT_OPERATIONS",
}

export enum INDUSTRY_AGRICULTURE {
  GROWERS = "GROWERS",
  INDOOR_GROWERS = "INDOOR_GROWERS",
  FARMERS = "FARMERS",
  NURSERIES = "NURSERIES",
}

export enum INDUSTRY_ARTS_RECREATION {
  ARTISTS = "ARTISTS",
  MUSICIANS = "MUSICIANS",
  WRITERS = "WRITERS",
  PERFORMERS = "PERFORMERS",
  VENUE_OPERATORS = "VENUE_OPERATORS",
  SPORTS_VENUE = "SPORTS_VENUE",
  GYMS = "GYMS",
  SPORTS_CLUB = "SPORTS_CLUB",
  AMUSEMENT_PARKS = "AMUSEMENT_PARKS",
  HORSE_RACING = "HORSE_RACING",
  DOG_RACING = "DOG_RACING",
  MUSEUMS = "MUSEUMS",
  ZOOS = "ZOOS",
  NATURE_RESERVES = "NATURE_RESERVES",
  BOTANICAL_GARDENS = "BOTANICAL_GARDENS",
  PARKS = "PARKS",
  CASINO = "CASINO",
  ONLINE_GAMBLING = "ONLINE_GAMBLING",
  LOTTERY_OPERATORS = "LOTTERY_OPERATORS",
}

export enum INDUSTRY_BUILDING_CONSTRUCTION {
  TRADES_SERVICES_CONSUMERS = "TRADES_SERVICES_CONSUMERS",
  TRADES_SERVICES_BUSINESSES_GOVERNMENT = "TRADES_SERVICES_BUSINESSES_GOVERNMENT",
  BUSINESSES_CONSTRUCTION_SERVICES = "BUSINESSES_CONSTRUCTION_SERVICES",
  BUSINESSES_LARGE_CONSTRUCTION_PROJECTS = "BUSINESSES_LARGE_CONSTRUCTION_PROJECTS",
  BUSINESSES_INFRASTRUCTURE_PROJECT = "BUSINESSES_INFRASTRUCTURE_PROJECT",
}

export enum INDUSTRY_FINANCIAL_INSURANCE {
  INVESTMENT_ADVISERS = "INVESTMENT_ADVISERS",
  STOCKBROKERS = "STOCKBROKERS",
  FINANCIAL_PLANNERS = "FINANCIAL_PLANNERS",
  WEALTH_MANAGEMENT_FIRMS = "WEALTH_MANAGEMENT_FIRMS",
  INSURANCE_AGENTS_BROKERS = "INSURANCE_AGENTS_BROKERS",
  SUPERANNUATION_PROVIDERS = "SUPERANNUATION_PROVIDERS",
  INSURANCE_COMPANIES = "INSURANCE_COMPANIES",
}

export enum INDUSTRY_FISHERIES {
  FISHING_BUSINESSES = "FISHING_BUSINESSES",
  HUNTING_BUSINESSES = "HUNTING_BUSINESSES",
  TRAPPING_BUSINESSES = "TRAPPING_BUSINESSES",
  AQUACULTURE_BUSINESSES = "AQUACULTURE_BUSINESSES",
}

export enum INDUSTRY_FORESTRY {
  GATHERING_GROWING_ACTIVITIES = "GATHERING_GROWING_ACTIVITIES",
  PLANTATION_CULTIVATION = "PLANTATION_CULTIVATION",
  PLANTATION_HARVESTING = "PLANTATION_HARVESTING",
  LOGGING = "LOGGING",
}

export enum INDUSTRY_HEALTH_BEAUTY {
  CHIROPRACTIC_OSTEOPATHIC_SERVICES = "CHIROPRACTIC_OSTEOPATHIC_SERVICES",
  COSMETICS_SUPPLIES = "COSMETICS_SUPPLIES",
  DAY_SPAS_HEALTH_RETREATS = "DAY_SPAS_HEALTH_RETREATS",
  DENTAL_SERVICES = "DENTAL_SERVICES",
  GENERAL_PRACTICE_MEDICAL_SERVICES = "GENERAL_PRACTICE_MEDICAL_SERVICES",
  HAIR_BEAUTY_SALONS = "HAIR_BEAUTY_SALONS",
  HEALTH_FOODS_NUTRITION_SUPPLEMENTS = "HEALTH_FOODS_NUTRITION_SUPPLEMENTS",
  OPTOMETRY_SERVICES = "OPTOMETRY_SERVICES",
  PATHOLOGY_IMAGING_SERVICES = "PATHOLOGY_IMAGING_SERVICES",
  PHYSIOTHERAPY_SERVICES = "PHYSIOTHERAPY_SERVICES",
  SPECIALIST_MEDICAL_SERVICES = "SPECIALIST_MEDICAL_SERVICES",
  OTHER_HEALTH_BEAUTY = "OTHER_HEALTH_BEAUTY",
}

export enum INDUSTRY_INFORMATION_TELECOMMUNICATION {
  NEWSPAPER_PUBLISHING = "NEWSPAPER_PUBLISHING",
  SOFTWARE_PUBLISHING = "SOFTWARE_PUBLISHING",
  MOTION_PICTURE = "MOTION_PICTURE",
  RADIO_TELEVISION = "RADIO_TELEVISION",
  INTERNET_PUBLISHING = "INTERNET_PUBLISHING",
  TELECOMMUNICATION_SERVICES = "TELECOMMUNICATION_SERVICES",
  DATA_PROCESSING_SERVICES = "DATA_PROCESSING",
  LIBRARY_SERVICES = "LIBRARY_SERVICES",
}

export enum INDUSTRY_MANUFACTURING {
  FOOD_PROCESSING = "FOOD_PROCESSING",
  BEVERAGES = "BEVERAGES",
  TEXTILE = "TEXTILE",
  WOOD_PRODUCTS = "WOOD_PRODUCTS",
  PULP_AND_PAPER = "PULP_AND_PAPER",
  PRINTING = "PRINTING",
  CHEMICAL = "CHEMICAL",
  METAL_AND_PLASTICS = "METAL_AND_PLASTICS",
  MACHINARY_EQUIPMENT = "MACHINARY_EQUIPMENT",
  FURNITURE = "FURNITURE",
  HOUSEHOLD_GOOD = "HOUSEHOLD_GOOD",
  WHOLE_OR_PARTIAL = "WHOLE_OR_PARTIAL",
}

export enum INDUSTRY_PROFESSIONAL {
  SCIENTISTS = "SCIENTISTS",
  ACCOUNTANTS = "ACCOUNTANTS",
  ADVERTISING_MARKETING_SPECIALISTS = "ADVERTISING_MARKETING_SPECIALISTS",
  LAWYERS = "LAWYERS",
  VETS = "VETS",
  MANAGEMENT = "MANAGEMENT",
  PHOTOGRAPHERS = "PHOTOGRAPHERS",
  ARCHITECTS = "ARCHITECTS",
  ENGINEERS = "ENGINEERS",
  COMPUTER_SYSTEM_DESIGNERS = "COMPUTER_SYSTEM_DESIGNERS",
}

export enum INDUSTRY_RENTAL_REAL_ESTATE {
  PROPERTY_OPERATORS = "PROPERTY_OPERATORS",
  REAL_ESTATE_SERVICES = "REAL_ESTATE_SERVICES",
  MOTOR_VEHICLES = "MOTOR_VEHICLES",
  TRANSPORT_EQUIPMENT = "TRANSPORT_EQUIPMENT",
  FARM_ANIMALS = "FARM_ANIMALS",
  VIDEO_ELECTRONIC_MEDIA = "VIDEO_ELECTRONIC_MEDIA",
  HEAVY_MACHINERY = "HEAVY_MACHINERY",
  SCAFFOLDING = "SCAFFOLDING",
  FURNITURE_APPLIANCES = "FURNITURE_APPLIANCES",
  INTANGIBLE_ASSETS = "INTANGIBLE_ASSETS",
}

export enum INDUSTRY_RETAIL_WHOLESALE_TRADE {
  ELECTRICAL = "ELECTRICAL",
  FURNITURE_HOUSEWARES = "FURNITURE_HOUSEWARES",
  FOOD_GROCERY = "FOOD_GROCERY",
  FUEL = "FUEL",
  HARDWARE_SUPPLIES = "HARDWARE_SUPPLIES",
  MOTOR_VEHICLES = "MOTOR_VEHICLES",
  CLOTHING_FOOTWEAR = "CLOTHING_FOOTWEAR",
  PERSONAL_ACCESSORIES = "PERSONAL_ACCESSORIES",
  PHARMACEUTICALS_COSMETICS = "PHARMACEUTICALS_COSMETICS",
  RECREATIONAL_GOODS = "RECREATIONAL_GOODS",
  TEXTILES = "TEXTILES",
  BOOKS_OFFICE_SUPPLIES = "BOOKS_OFFICE_SUPPLIES",
}

export enum INDUSTRY_TOURISM {
  TOUR_OPERATORS = "TOUR_OPERATORS",
  TRAVEL_AGENTS = "TRAVEL_AGENTS",
  SHORT_TERM_ACCOMODATIONS = "SHORT_TERM_ACCOMODATIONS",
  RECREATION_SERVICE_PROVIDERS = "RECREATION_SERVICE_PROVIDERS",
  TRANSPORT_SERVICE_PROVIDERS = "TRANSPORT_SERVICE_PROVIDERS",
}

export enum INDUSTRY_TRANSPORT_WAREHOUSING {
  TAXI_LUXURY_CAR_SERVICES = "TAXI_LUXURY_CAR_SERVICES",
  PASSENGERS_FREIGHT_TRANSPORT = "PASSENGERS_FREIGHT_TRANSPORT",
  POSTAL_DELIVERY = "POSTAL_DELIVERY",
  SCENIC_SIGHTSEEING = "SCENIC_SIGHTSEEING",
  WAREHOUSING = "WAREHOUSING",
}

export const INDUSTRY_LABELS: Dictionary = {
  [INDUSTRY.ACCOMODATION_FOOD]: "Accomodation & Food Services",
  [INDUSTRY.ADMINISTRATIVE_SUPPORT]: "Administrative & Support Services",
  [INDUSTRY.AGRICULTURE]: "Agriculture",
  [INDUSTRY.ARTS_RECREATION]: "Arts & Recreation Services",
  [INDUSTRY.BUILDING_CONSTRUCTION]: "Building and Construction",
  [INDUSTRY.FINANCIAL_INSURANCE]: "Financial & Insurance Services",
  [INDUSTRY.FISHERIES]: "Fisheries",
  [INDUSTRY.FORESTRY]: "Forestry",
  [INDUSTRY.HEALTH_BEAUTY]: "Health & Beauty",
  [INDUSTRY.INFORMATION_TELECOMMUNICATION]:
    "Information Media & Telecommunication",
  [INDUSTRY.MANUFACTURING]: "Manufacturing",
  [INDUSTRY.PROFESSIONAL]: "Professional, Scientific and Technical Services",
  [INDUSTRY.RENTAL_REAL_ESTATE]: "Rental, Hiring and Real Estate Services",
  [INDUSTRY.RETAIL_WHOLESALE_TRADE]: "Retail & Wholesale Trade",
  [INDUSTRY.TOURISM]: "Tourism",
  [INDUSTRY.TRANSPORT_WAREHOUSING]: "Transport, Postal & Warehousing Services",
};

export const INDUSTRY_OPTIONS: Dictionary = {
  [INDUSTRY.ACCOMODATION_FOOD]: {
    [INDUSTRY_ACCOMODATION_FOOD.HOTELS]: "Hotels",
    [INDUSTRY_ACCOMODATION_FOOD.MOTELS]: "Motels",
    [INDUSTRY_ACCOMODATION_FOOD.SERVICED_APARTMENTS]: "Serviced Apartments",
    [INDUSTRY_ACCOMODATION_FOOD.OTHER_ACCOMODATION]:
      "Other Short-term Accomodation",
    [INDUSTRY_ACCOMODATION_FOOD.CAFES]: "Cafes",
    [INDUSTRY_ACCOMODATION_FOOD.RESTAURANTS]: "Restaurants",
    [INDUSTRY_ACCOMODATION_FOOD.TAKEAWAYS]: "Takeaways",
    [INDUSTRY_ACCOMODATION_FOOD.PUBS]: "Pubs",
    [INDUSTRY_ACCOMODATION_FOOD.BARS]: "Bars",
    [INDUSTRY_ACCOMODATION_FOOD.OTHER_FOOD]: "Other ",
  },
  [INDUSTRY.ADMINISTRATIVE_SUPPORT]: {
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.EMPLOYMENT]: "Employment Services",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.ADMINISTRATIVE]: "Administrative Services",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.DOMESTIC_COMMERCIAL_CLEANING]:
      "Domestic & Commercial Cleaning",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.PEST_CONTROL]: "Pest Control",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.GARDENING]: "Gardening Services",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.PACKAGING]: "Packaging Services",
    [INDUSTRY_ADMINISTRATIVE_SUPPORT.SUPPORT_OPERATIONS]:
      "Support Activities for the Day-to-day Operations of Other Businesses/Organisations",
  },
  [INDUSTRY.AGRICULTURE]: {
    [INDUSTRY_AGRICULTURE.GROWERS]:
      "Growers - Turf, Flowers, Vegetables, Fruit, Nuts, Grain & Other Crops",
    [INDUSTRY_AGRICULTURE.INDOOR_GROWERS]:
      "Growers Using Indoor or Covered Growing Techniques & Technology",
    [INDUSTRY_AGRICULTURE.FARMERS]:
      "Farmers - Sheep, Cattle, Poultry, Deer & Other Livestock",
    [INDUSTRY_AGRICULTURE.NURSERIES]: "Nurseries",
  },
  [INDUSTRY.ARTS_RECREATION]: {
    [INDUSTRY_ARTS_RECREATION.ARTISTS]: "Artists",
    [INDUSTRY_ARTS_RECREATION.MUSICIANS]: "Musicians",
    [INDUSTRY_ARTS_RECREATION.WRITERS]: "Writers",
    [INDUSTRY_ARTS_RECREATION.PERFORMERS]: "Performers",
    [INDUSTRY_ARTS_RECREATION.VENUE_OPERATORS]: "Venue Operators",
    [INDUSTRY_ARTS_RECREATION.SPORTS_VENUE]: "Sports Venue",
    [INDUSTRY_ARTS_RECREATION.GYMS]: "Gyms",
    [INDUSTRY_ARTS_RECREATION.SPORTS_CLUB]: "Sports Club",
    [INDUSTRY_ARTS_RECREATION.AMUSEMENT_PARKS]: "Amusement Parks",
    [INDUSTRY_ARTS_RECREATION.HORSE_RACING]: "Horse Racing",
    [INDUSTRY_ARTS_RECREATION.DOG_RACING]: "Dog Racing",
    [INDUSTRY_ARTS_RECREATION.MUSEUMS]: "Museums",
    [INDUSTRY_ARTS_RECREATION.ZOOS]: "Zoos",
    [INDUSTRY_ARTS_RECREATION.NATURE_RESERVES]: "Nature Reserves",
    [INDUSTRY_ARTS_RECREATION.BOTANICAL_GARDENS]: "Botanical Gardens",
    [INDUSTRY_ARTS_RECREATION.PARKS]: "Parks",
    [INDUSTRY_ARTS_RECREATION.CASINO]: "Casino",
    [INDUSTRY_ARTS_RECREATION.ONLINE_GAMBLING]: "Online Gambling",
    [INDUSTRY_ARTS_RECREATION.LOTTERY_OPERATORS]: "Lottery Operators",
  },
  [INDUSTRY.BUILDING_CONSTRUCTION]: {
    [INDUSTRY_BUILDING_CONSTRUCTION.TRADES_SERVICES_CONSUMERS]:
      "Trades People Providing Services Direct to Consumers",
    [INDUSTRY_BUILDING_CONSTRUCTION.TRADES_SERVICES_BUSINESSES_GOVERNMENT]:
      "Trades People Providing Services to Other Building & Construction Businesses & Government",
    [INDUSTRY_BUILDING_CONSTRUCTION.BUSINESSES_CONSTRUCTION_SERVICES]:
      "Businesses Providing Small & Large Construction Services to Individuals & Government",
    [INDUSTRY_BUILDING_CONSTRUCTION.BUSINESSES_LARGE_CONSTRUCTION_PROJECTS]:
      "Businesses Engaged in Large Construction Projects",
    [INDUSTRY_BUILDING_CONSTRUCTION.BUSINESSES_INFRASTRUCTURE_PROJECT]:
      "Businesses Engaged in Infrastructure Project",
  },
  [INDUSTRY.FINANCIAL_INSURANCE]: {
    [INDUSTRY_FINANCIAL_INSURANCE.INVESTMENT_ADVISERS]: "Investment Advisers",
    [INDUSTRY_FINANCIAL_INSURANCE.STOCKBROKERS]: "Strockbrokers",
    [INDUSTRY_FINANCIAL_INSURANCE.FINANCIAL_PLANNERS]: "Financial Planners",
    [INDUSTRY_FINANCIAL_INSURANCE.WEALTH_MANAGEMENT_FIRMS]:
      "Wealth Management Firms",
    [INDUSTRY_FINANCIAL_INSURANCE.INSURANCE_AGENTS_BROKERS]:
      "Insurance Agents & Brokers",
    [INDUSTRY_FINANCIAL_INSURANCE.SUPERANNUATION_PROVIDERS]:
      "Superannuation Providers",
    [INDUSTRY_FINANCIAL_INSURANCE.INSURANCE_COMPANIES]: "Insurance Companies",
  },
  [INDUSTRY.FISHERIES]: {
    [INDUSTRY_FISHERIES.FISHING_BUSINESSES]: "Fishing Businesses",
    [INDUSTRY_FISHERIES.HUNTING_BUSINESSES]: "Hunting Businesses",
    [INDUSTRY_FISHERIES.TRAPPING_BUSINESSES]: "Trapping Businesses",
    [INDUSTRY_FISHERIES.AQUACULTURE_BUSINESSES]: "Aquaculture Businesses",
  },
  [INDUSTRY.FORESTRY]: {
    [INDUSTRY_FORESTRY.GATHERING_GROWING_ACTIVITIES]:
      "Forestry Gathering and Growing Activities",
    [INDUSTRY_FORESTRY.PLANTATION_CULTIVATION]: "Plantation Cultivation",
    [INDUSTRY_FORESTRY.PLANTATION_HARVESTING]: "Plantation Harvesting",
    [INDUSTRY_FORESTRY.LOGGING]: "Logging Activities",
  },
  [INDUSTRY.HEALTH_BEAUTY]: {
    [INDUSTRY_HEALTH_BEAUTY.CHIROPRACTIC_OSTEOPATHIC_SERVICES]:
      "Chiropractic, Osteopathic Services",
    [INDUSTRY_HEALTH_BEAUTY.COSMETICS_SUPPLIES]: "Cosmetics Supplies",
    [INDUSTRY_HEALTH_BEAUTY.DAY_SPAS_HEALTH_RETREATS]:
      "Day Spas, Health Retreats",
    [INDUSTRY_HEALTH_BEAUTY.DENTAL_SERVICES]: "Dental Services",
    [INDUSTRY_HEALTH_BEAUTY.GENERAL_PRACTICE_MEDICAL_SERVICES]:
      "General Practice Medical Services",
    [INDUSTRY_HEALTH_BEAUTY.HAIR_BEAUTY_SALONS]: "Hair, Beauty Salons",
    [INDUSTRY_HEALTH_BEAUTY.HEALTH_FOODS_NUTRITION_SUPPLEMENTS]:
      "Health Foods, Nutrition, Supplements",
    [INDUSTRY_HEALTH_BEAUTY.OPTOMETRY_SERVICES]: "Optometry Services",
    [INDUSTRY_HEALTH_BEAUTY.PATHOLOGY_IMAGING_SERVICES]:
      "Pathology & Imaging Services",
    [INDUSTRY_HEALTH_BEAUTY.PHYSIOTHERAPY_SERVICES]: "Physiotherapy Services",
    [INDUSTRY_HEALTH_BEAUTY.SPECIALIST_MEDICAL_SERVICES]:
      "Specialist Medical Services",
    [INDUSTRY_HEALTH_BEAUTY.OTHER_HEALTH_BEAUTY]: "Other Health & Beauty",
  },
  [INDUSTRY.INFORMATION_TELECOMMUNICATION]: {
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.NEWSPAPER_PUBLISHING]:
      "Newspaper, Magazine, Book and Directory Publishing",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.SOFTWARE_PUBLISHING]:
      "Software Publishing",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.MOTION_PICTURE]:
      "Motion Picture and Sound Recording and Distribution",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.RADIO_TELEVISION]:
      "Radio & Television Broadcasting",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.INTERNET_PUBLISHING]:
      "Internet Publishing & Broadcasting",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.TELECOMMUNICATION_SERVICES]:
      "Telecommunication Services, ISP and Web Search Portals",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.DATA_PROCESSING_SERVICES]:
      "Data Processing, Web Hosting and Electronic Information Storage Services",
    [INDUSTRY_INFORMATION_TELECOMMUNICATION.LIBRARY_SERVICES]:
      "Library & Other Information Services",
  },
  [INDUSTRY.MANUFACTURING]: {
    [INDUSTRY_MANUFACTURING.FOOD_PROCESSING]: "Food Processing & Manufacturing",
    [INDUSTRY_MANUFACTURING.BEVERAGES]: "Bottled Drinks & Brewed Beverages",
    [INDUSTRY_MANUFACTURING.TEXTILE]:
      "Textile, Leather, Clothing, Footwear and Accessories",
    [INDUSTRY_MANUFACTURING.WOOD_PRODUCTS]: "Wood Products",
    [INDUSTRY_MANUFACTURING.PULP_AND_PAPER]: "Pulp and Paper Products",
    [INDUSTRY_MANUFACTURING.PRINTING]:
      "Printing (Small & Large Production Runs)",
    [INDUSTRY_MANUFACTURING.CHEMICAL]: "Chemical Manufacturing and Processing",
    [INDUSTRY_MANUFACTURING.METAL_AND_PLASTICS]:
      "Metal & Plastics Manufacturing",
    [INDUSTRY_MANUFACTURING.MACHINARY_EQUIPMENT]:
      "Machinery & Equipment Manufacturing",
    [INDUSTRY_MANUFACTURING.HOUSEHOLD_GOOD]: "Household Goods Production",
    [INDUSTRY_MANUFACTURING.WHOLE_OR_PARTIAL]:
      "Whole or Partial Product Manufacturing",
  },
  [INDUSTRY.PROFESSIONAL]: {
    [INDUSTRY_PROFESSIONAL.SCIENTISTS]: "Scientists",
    [INDUSTRY_PROFESSIONAL.ACCOUNTANTS]: "Accountants",
    [INDUSTRY_PROFESSIONAL.ADVERTISING_MARKETING_SPECIALISTS]:
      "Advertising & Marketing Specialists",
    [INDUSTRY_PROFESSIONAL.LAWYERS]: "Lawyers & Solicitors",
    [INDUSTRY_PROFESSIONAL.VETS]: "Vets",
    [INDUSTRY_PROFESSIONAL.MANAGEMENT]: "Management & Other Consultants",
    [INDUSTRY_PROFESSIONAL.PHOTOGRAPHERS]: "Photographers",
    [INDUSTRY_PROFESSIONAL.ARCHITECTS]: "Architects",
    [INDUSTRY_PROFESSIONAL.ENGINEERS]: "Engineers",
    [INDUSTRY_PROFESSIONAL.COMPUTER_SYSTEM_DESIGNERS]:
      "Computer System Designers",
  },
  [INDUSTRY.RENTAL_REAL_ESTATE]: {
    [INDUSTRY_RENTAL_REAL_ESTATE.PROPERTY_OPERATORS]: "Property operators",
    [INDUSTRY_RENTAL_REAL_ESTATE.REAL_ESTATE_SERVICES]: "Real estate services",
    [INDUSTRY_RENTAL_REAL_ESTATE.MOTOR_VEHICLES]: "Motor vehicles",
    [INDUSTRY_RENTAL_REAL_ESTATE.TRANSPORT_EQUIPMENT]: "Transport equipment",
    [INDUSTRY_RENTAL_REAL_ESTATE.FARM_ANIMALS]: "Farm Animals & Bloodstock",
    [INDUSTRY_RENTAL_REAL_ESTATE.VIDEO_ELECTRONIC_MEDIA]:
      "Video & Other Electronic Media",
    [INDUSTRY_RENTAL_REAL_ESTATE.HEAVY_MACHINERY]: "Heavy Machinery",
    [INDUSTRY_RENTAL_REAL_ESTATE.SCAFFOLDING]: "Scaffolding",
    [INDUSTRY_RENTAL_REAL_ESTATE.FURNITURE_APPLIANCES]:
      "Furniture & Appliances",
    [INDUSTRY_RENTAL_REAL_ESTATE.INTANGIBLE_ASSETS]:
      "Intangible Assets (e.g. patents & trademarks)",
  },
  [INDUSTRY.RETAIL_WHOLESALE_TRADE]: {
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.ELECTRICAL]:
      "Electrical, Electronic & Whitegoods",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.FURNITURE_HOUSEWARES]:
      "Floor Coverings, Furniture & Housewares",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.FOOD_GROCERY]: "Food & Grocery",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.FUEL]: "Fuel",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.HARDWARE_SUPPLIES]:
      "Hardware, Building & Garden Supplies",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.MOTOR_VEHICLES]:
      "Motor Vehicles & Trailers, Parts & Accessories",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.CLOTHING_FOOTWEAR]: "Clothing & Footwear",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.PERSONAL_ACCESSORIES]:
      "Personal Accessories",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.PHARMACEUTICALS_COSMETICS]:
      "Pharmaceuticals & Cosmetics",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.RECREATIONAL_GOODS]: "Recreational Goods",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.TEXTILES]: "Textiles",
    [INDUSTRY_RETAIL_WHOLESALE_TRADE.BOOKS_OFFICE_SUPPLIES]:
      "Books, Magazines, Papers & Office Supplies",
  },
  [INDUSTRY.TOURISM]: {
    [INDUSTRY_TOURISM.TOUR_OPERATORS]: "Tour Operators",
    [INDUSTRY_TOURISM.TRAVEL_AGENTS]: "Travel Agents",
    [INDUSTRY_TOURISM.SHORT_TERM_ACCOMODATIONS]: "Short Term Accomodations",
    [INDUSTRY_TOURISM.RECREATION_SERVICE_PROVIDERS]:
      "Recreation Service Providers",
    [INDUSTRY_TOURISM.TRANSPORT_SERVICE_PROVIDERS]:
      "Transport & Hire Service Providers",
  },
  [INDUSTRY.TRANSPORT_WAREHOUSING]: {
    [INDUSTRY_TRANSPORT_WAREHOUSING.TAXI_LUXURY_CAR_SERVICES]:
      "Taxi & Luxury Car Services",
    [INDUSTRY_TRANSPORT_WAREHOUSING.PASSENGERS_FREIGHT_TRANSPORT]:
      "Passengers & Freight Transport Services",
    [INDUSTRY_TRANSPORT_WAREHOUSING.POSTAL_DELIVERY]:
      "Postal, Courier Pick-up & Delivery Services",
    [INDUSTRY_TRANSPORT_WAREHOUSING.SCENIC_SIGHTSEEING]:
      "Scenic & Sightseeing Transport",
    [INDUSTRY_TRANSPORT_WAREHOUSING.WAREHOUSING]:
      "Warehousing Other Storage Activities",
  },
};
